import { useNavigate } from 'react-router-dom';
import { Alert, Form, Input, Button, Card, Typography, App, Space } from 'antd';
import { PhoneOutlined, LoginOutlined } from '@ant-design/icons';
import { useAuth } from '@/hooks/useAuth';

const { Title, Text } = Typography;

export function Login() {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const { requestOtp, isLoading, error } = useAuth();

  const onFinish = async (values: { phoneNumber: string }) => {
    const success = await requestOtp(values.phoneNumber);
    if (success) {
      message.success('OTP sent successfully!');
      navigate('/otp-verify');
    }
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f2f5',
      }}
    >
      <Card style={{ width: '100%', maxWidth: 400, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2}>mygate Backoffice</Title>
            <Text type="secondary">Staff Login Portal</Text>
          </div>

          {import.meta.env.VITE_ENV === 'production-preview' && (
            <Alert
              type="info"
              showIcon
              message="Live-Vorschau · Produktivdaten"
              description="Mit deinem regulären Backoffice-Zugang anmelden. Änderungsaktionen sind hier gesperrt."
            />
          )}

          {error && <Alert type="error" showIcon message={error} />}

          <Form name="login" onFinish={onFinish} layout="vertical" requiredMark={false}>
            <Form.Item
              label="Phone Number"
              name="phoneNumber"
              rules={[
                { required: true, message: 'Please enter your phone number' },
                {
                  pattern: /^\+?[1-9]\d{1,14}$/,
                  message: 'Please enter a valid phone number',
                },
              ]}
            >
              <Input prefix={<PhoneOutlined />} placeholder="+48797317090" size="large" disabled={isLoading} />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit" loading={isLoading} icon={<LoginOutlined />} size="large" block>
                Send OTP
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: 'center' }}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Only authorized staff members can access this portal
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  );
}
